var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common-space-from-logo" }, [
    _c("div", {}, [
      _c("h1", { staticClass: "mb-13 template-title" }, [
        _vm._v("Ready to send? Make sure this is right:")
      ]),
      _vm._v(" "),
      _vm.community.content && _vm.community.content.formConfirmation
        ? _c("p", {
            staticClass: "custom-content chatbot-custom-content",
            domProps: {
              innerHTML: _vm._s(_vm.community.content.formConfirmation)
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "chatbot-request-review-hr" }),
    _vm._v(" "),
    _c("div", { staticClass: "email-request-review" }, [
      _c("div", { staticClass: "template-request-review" }, [
        _vm.ask.first && _vm.ask.last
          ? _c("h2", [_vm._v(_vm._s(_vm.ask.first + " " + _vm.ask.last))])
          : _vm._e(),
        _vm._v(" "),
        _vm.ask.email
          ? _c("h5", [_vm._v(_vm._s(_vm.ask.email.toString()))])
          : _vm._e(),
        _vm._v(" "),
        _c("h6", [_vm._v(_vm._s(_vm.ask.subject))]),
        _vm._v(" "),
        _c("p", { staticClass: "font-color" }, [_vm._v(_vm._s(_vm.ask.text))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-block" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn_info btn-feedbackupdatenew active template-button",
              style: _vm.styleSubmitBtn,
              on: {
                click: function($event) {
                  return _vm.sendCreate()
                }
              }
            },
            [_vm._v("Submit")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right" },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn editBtn btn-feedbackupdatenew btn_info template-button",
                style: _vm.styleEditBtn,
                on: {
                  click: function($event) {
                    return _vm.editCreate()
                  }
                }
              },
              [_vm._v("Edit")]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aae3686", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aae3686","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunityRequestReviewPage.vue
// module id = null
// module chunks = 